(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/racing-game/components/play/assets/javascripts/use-play-redirects.js') >= 0) return;  svs.modules.push('/modules/racing-game/components/play/assets/javascripts/use-play-redirects.js');
"use strict";

function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }

const {
  useCallback,
  useEffect
} = React;
const {
  useHistory,
  useLocation
} = ReactRouterDOM;
const {
  buildLocationFromRace
} = svs.racing.navigation.location;

const usePlayRedirects = (race, navigation, toXpert, hasXpert) => {
  const history = useHistory();
  const location = useLocation();
  useEffect(() => {
    if (race && (!navigation.day || !navigation.trackName || !navigation.raceNumber || !navigation.gameType)) {
      history.replace(_objectSpread(_objectSpread({}, location), {}, {
        pathname: buildLocationFromRace(race).pathname
      }));
    }
  }, [race, navigation.day, navigation.trackName, navigation.raceNumber, navigation.gameType]);
  const redirectDefaultXpert = useCallback(() => {
    if (navigation.row) {
      svs.components.Storage.browser.remove('defaultXpertMode', 'Racing');
    } else {
      const defaultXpertMode = svs.components.Storage.browser.get('defaultXpertMode', 'Racing');
      if (defaultXpertMode !== undefined && defaultXpertMode !== navigation.isXpert) {
        toXpert(defaultXpertMode);
      }
    }
  }, [toXpert, navigation.isXpert]);

  useEffect(() => {
    if (hasXpert) {
      redirectDefaultXpert();
    }
  }, [hasXpert, navigation.isXpert]);
};
svs.racing_game.components.play.usePlayRedirects = usePlayRedirects;

 })(window);